export default {
  retrievedBuildingComplexes: (state, buildingComplexes) => {
    state.buildingComplexes = buildingComplexes;
  },

  buildingComplexesList: (state, buildingComplexes) => {
    state.buildingComplexesList = buildingComplexes;
  },

  setFilters: (state, filters) => {
    state.filters = filters;
  },

  setPaginationOptions: (state, paginationOptions) => {
    state.paginationOptions = paginationOptions;
  }
};
